import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { DocEntry, docPath } from "../docsManifest";
import { DOCS_ACCENT, DOCS_MUTED } from "../docsStyles";

interface PagerLinkProps {
  doc: DocEntry;
  label: string;
  align: "left" | "right";
}

export const PagerLink = ({ doc, label, align }: PagerLinkProps) => (
  <Box
    component={Link}
    to={docPath(doc.slug)}
    sx={{
      display: "block",
      // A 44px-plus tap target on a phone, full width so it's easy to hit.
      minHeight: 44,
      textAlign: { xs: "left", sm: align },
      textDecoration: "none",
      "&:hover .pager-title": { textDecoration: "underline" },
    }}
  >
    <Typography
      component="span"
      sx={{ display: "block", fontSize: 12, color: DOCS_MUTED }}
    >
      {label}
    </Typography>
    <Typography
      component="span"
      className="pager-title"
      sx={{
        display: "block",
        fontSize: 14,
        fontWeight: 500,
        color: DOCS_ACCENT,
        lineHeight: 1.35,
      }}
    >
      {doc.title}
    </Typography>
  </Box>
);
